import { render } from "./Authentication.vue?vue&type=template&id=68f7ed88&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"

import "./Authentication.vue?vue&type=style&index=0&id=68f7ed88&scoped=true&lang=css"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f7ed88"]])

export default __exports__